// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import './IconButton.css';

interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'square-filled' | 'round-filled' | 'square-outlined' | 'round-outlined' | 'ghost';
  size?: 'lg' | 'md' | 'sm' | 'xs';
  icon: React.ReactNode;
}

export function IconButton({
  variant = 'round-filled',
  size = 'md',
  icon,
  className = '',
  ...rest
}: IconButtonProps) {
  const classes = [
    'fin-icon-btn',
    `fin-icon-btn--${variant}`,
    `fin-icon-btn--${size}`,
    'focus:outline-none focus-visible:outline-none',
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} {...rest}>
      {icon}
    </button>
  );
}
